<template>
  <div class="relative" v-loading="loading">
    <div class="pr-291px h-full">
      <div class="flex items-center justify-between text-18px">
        <span>试卷名称：{{ paperData.ExamName }}</span>
        <!-- <el-button type="primary" size="small" @click="download">下载</el-button> -->
      </div>
      <div class="overflow-y-auto h-[calc(100%-36px)]" @scroll="onScroll" ref="topicContent">
        <template v-for="item in topicList">
          <div
            v-if="item.children.length"
            :key="item.type"
            class="mt-10px"
            :ref="`topicType${item.type}`"
          >
            <div class="border-l-3 border-color-primary pl-10px text-16px">
              {{ item.name }}（{{ item.description }}），共{{ item.children.length }}题，共{{
                item.score
              }}分
            </div>
            <div v-for="topic in item.children" :key="topic.id" class="mt-10px">
              <div class="text-14px">
                {{ topic.seqNo }}.{{ topic.title
                }}<span v-if="![3, 4].includes(item.type)">（{{ topic.answer }}）</span>
              </div>
              <el-radio-group v-model="topic.correct" v-if="item.type === 0" disabled>
                <el-radio
                  :label="words[optionIndex]"
                  v-for="(option, optionIndex) in topic.content"
                  :key="optionIndex"
                  >{{ words[optionIndex] }}.{{ option.content }}</el-radio
                >
              </el-radio-group>
              <el-checkbox-group v-model="topic.correct" v-else-if="item.type === 1" disabled>
                <el-checkbox
                  :label="words[optionIndex]"
                  v-for="(option, optionIndex) in topic.content"
                  :key="optionIndex"
                  >{{ words[optionIndex] }}.{{ option.content }}</el-checkbox
                >
              </el-checkbox-group>
              <el-radio-group v-model="topic.correct" v-else-if="item.type === 2" disabled>
                <el-radio label="对">对</el-radio>
                <el-radio label="错">错</el-radio>
              </el-radio-group>
              <el-input
                size="small"
                v-model="topic.answer"
                disabled
                class="mt-10px"
                v-else-if="item.type === 3"
              />
              <el-input
                size="small"
                v-model="topic.answer"
                disabled
                class="mt-10px"
                type="textarea"
                :rows="3"
                v-else
              />
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="w-291px absolute right-0px top-0px pl-20px h-full overflow-y-auto">
      <div class="px-10px border-left-1px border-color-default text-14px">
        <div class="text-16px">考试成绩</div>
        <div class="flex justify-between items-center p-5px bg-table-header mt-10px">
          <div>
            <span class="text-[#ff0000] text-36px">{{ paperData.Score }}</span
            >分
          </div>
          <img :src="paperData.img" class="w-40px" />
        </div>
        <el-row :gutter="10" class="mt-10px">
          <el-col :span="12">姓名：{{ paperData.ExamineeName }}</el-col>
          <!-- <el-col :span="12">工号：{{ paperData.examineeCode }}</el-col> -->
        </el-row>
        <div class="mt-10px">部门：{{ paperData.DeptName }}</div>
        <div class="flex justify-between text-15px mt-20px">
          <span class="font-bold">答题卡</span>
          <div>
            <span class="text-[var(--systemMainColor)]">{{
              sheetData.sheetList.filter((item) => {
                return item.answer
              }).length
            }}</span>
            <span class="text-[var(--secondaryTextColor)]">/{{ sheetData.sheetList.length }}</span>
          </div>
        </div>
        <div class="mt-5px">
          <div
            v-for="item in sheetData.sheetList"
            :key="item.id"
            class="inline-block w-30px h-30px leading-30px text-center border-1px border-color-default mt-5px rounded-2px text-[var(--secondaryTextColor)]"
            :style="{
              marginRight: item.seqNo % 7 === 0 ? '0' : '5px',
            }"
            :class="{
              'right-answer': item.answer === item.correct.toString(),
              'wrong-answer': item.answer && item.answer !== item.correct.toString(),
            }"
          >
            {{ item.seqNo }}
          </div>
        </div>
        <div class="mt-20px text-[var(--secondaryTextColor)]">
          <template v-for="item in sheetData.statistics">
            <div
              v-if="item.topicLength > 0"
              :key="item.name"
              class="flex justify-between mt-15px cursor-pointer topic-type relative"
              :class="{
                'text-[var(--systemMainColor)]': currentType === item.type,
              }"
              @click="toTopicType(item.type)"
            >
              <div>{{ item.name }}</div>
              <div>
                <span
                  :style="{
                    color:
                      item.answerLength > 0 || currentType === item.type
                        ? 'var(--systemMainColor)'
                        : 'var(--secondaryTextColor)',
                  }"
                  >{{ item.answerLength }}</span
                >
                <span>/{{ item.topicLength }}</span>
              </div>
              <div
                class="w-12px h-12px rounded-1/2 absolute -left-16px bg-[var(--systemMainColor)]"
                v-if="currentType === item.type"
              ></div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { forEach, find, sumBy, map, flatten } from 'lodash'
import DiyService from '@/modules/educational-training-management-sm/services/DiyService'
import { wordsList } from '@/components/safety/enumField/enumTagType'
const passImg = require('../../images/pass.png')
const noPassImg = require('../../images/no_pass.png')

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      paperData: {},
      loading: false,
      topicList: [
        {
          name: '单选题',
          description: '每题只有一个正确答案',
          type: 0,
          score: 0,
          children: [],
        },
        {
          name: '多选题',
          description: '每题可以有多个正确答案',
          type: 1,
          score: 0,
          children: [],
        },
        {
          name: '判断题',
          description: '选对或错',
          type: 2,
          score: 0,
          children: [],
        },
        {
          name: '填空题',
          description: '填写题目中空出来的内容',
          type: 3,
          score: 0,
          children: [],
        },
        {
          name: '简答题',
          description: '简单回答',
          type: 4,
          score: 0,
          children: [],
        },
      ],
      words: wordsList,
      currentType: 0,
      disabledScroll: false,
    }
  },
  computed: {
    sheetData() {
      const list = map(this.topicList, (item) => {
        return {
          name: item.name,
          type: item.type,
          topicLength: item.children.length,
          answerLength: item.children.filter((topic) => {
            return topic.answer
          }).length,
        }
      })
      return {
        statistics: list,
        sheetList: flatten(map(this.topicList, 'children')),
      }
    },
  },
  methods: {
    async getExamPaper() {
      this.loading = true
      const params = {
        ApiEngineKey: 'get_current_paper',
        PaperId: this.id,
      }
      const [err, res] = await DiyService.getInterfaceList(params)
      if (!err && res.Code === 1) {
        this.paperData = {
          ...res.Data,
          img: res.Data.IsPass ? passImg : noPassImg,
        }
        forEach(res.Data.TopicTypes, (item) => {
          const topicType = find(this.topicList, { type: item.QuestionType })
          if (topicType) {
            topicType.children = map(item.TopicContents, (topic) => {
              let answer
              if (!topic.ExamineeAnswerContent) {
                answer = ''
              } else if (topic.ExamType === 1) {
                answer = topic.ExamineeAnswerContent.split(',')
                  .sort()
                  .join(',')
              } else if (topic.ExamType === 2) {
                answer = topic.ExamineeAnswerContent === 'A' ? '对' : '错'
              } else {
                answer = topic.ExamineeAnswerContent
              }
              let correct = topic.Correct
              if (topic.ExamType === 1) {
                correct = topic.Correct.split(',')
              } else if (topic.ExamType === 2) {
                correct = topic.Correct === 'A' ? '对' : '错'
              }
              let topicContent
              try {
                topicContent = topic.TopicContent
              } catch (error) {
                topicContent = []
              }
              return {
                correct,
                score: topic.Score,
                seqNo: topic.Ordination,
                title: topic.Topic,
                answer,
                id: topic.Id,
                content: topicContent,
              }
            })
            topicType.score = sumBy(topicType.children, 'score')
          }
        })
        this.currentType =
          find(this.topicList, (item) => {
            return item.children > 0
          })?.type || 0
        this.$nextTick(() => {
          forEach(this.topicList, (item) => {
            const topicTypeDom =
              this.$refs[`topicType${item.type}`] && this.$refs[`topicType${item.type}`][0]
            if (topicTypeDom) {
              item.scrollMax = topicTypeDom.offsetTop - 36 + topicTypeDom.offsetHeight
            }
          })
        })
      } else {
        this.$message.error(res.Msg)
      }
      this.loading = false
    },
    // async download() {
    //   const [err, res] = await textContentApi.downloadPaper({
    //     body: [this.paperData.markingPaperTextContentId],
    //   })
    //   if (!err) {
    //     download(`${this.paperData.examName}.pdf`, res, 'application/pdf')
    //   }
    // },
    toTopicType(type) {
      this.currentType = type
      const topicTypeDom = this.$refs[`topicType${type}`] && this.$refs[`topicType${type}`][0]
      if (topicTypeDom) {
        this.disabledScroll = true
        topicTypeDom.scrollIntoView(true)
        setTimeout(() => {
          this.disabledScroll = false
        })
      }
    },
    onScroll(e) {
      if (!this.topicList || this.topicList.length === 0) return
      
      const scrollTop = e.target.scrollTop
      const foundItem = find(this.topicList, (item) => {
        return item && item.scrollMax && scrollTop <= item.scrollMax
      })
      
      this.currentType = foundItem ? foundItem.type : 0
    },
  },
  created() {
    this.getExamPaper()
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-radio-group {
  .el-radio {
    display: block;
    margin-top: 10px;
  }
}
::v-deep .el-checkbox-group {
  .el-checkbox {
    display: block;
    margin-top: 10px;
  }
}
.right-answer {
  color: rgb(60, 195, 94);
  background-color: rgba(184, 255, 202, 0.5);
  border-color: rgb(60, 195, 94) !important;
}
.wrong-answer {
  color: rgb(255, 80, 71);
  background-color: rgba(255, 202, 199, 0.5);
  border-color: rgb(255, 80, 71) !important;
}
</style>
